<template>
  <div class="modal fade createNewModal" id="AddModalTarification" tabindex="-1" ref="addTarificationModalRef"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
          <h5 class="modal-title fw-bold text-black">{{ title }}</h5>
        </div>
        <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
          <Form ref="tarificationForm" @submit="addTarification" :validation-schema="tarificationSchema">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Cout <span class="text-danger">*</span>
                  </label>
                  <Field name="cout" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le cout" />
                  <ErrorMessage name="cout" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Zone <span class="text-danger">*</span>
                  </label>
                  <Field name="zone" v-slot="{ field }">
                    <Multiselect :options="zoneOptions" :searchable="true" multiple="false" track-by="label"
                      label="label" v-model="field.value" v-bind="field" placeholder="Sélectionner la zone" />
                  </Field>
                  <ErrorMessage name="zone" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Type de cargaison <span class="text-danger">*</span>
                  </label>
                  <Field name="typeCargaison" v-slot="{ field }">
                    <Multiselect :options="typeCargaisonOptions" :searchable="true" multiple="false" track-by="label"
                      label="label" v-model="field.value" v-bind="field" placeholder="Sélectionner la zone" />
                  </Field>
                  <ErrorMessage name="typeCargaison" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                   Régime Douanier <span class="text-danger">*</span>
                  </label>
                  <Field name="regimeDouanier" v-slot="{ field }">
                    <Multiselect :options="regimeDouanierOptions" :searchable="true" multiple="false" track-by="label"
                      label="label" v-model="field.value" v-bind="field" placeholder="Sélectionner le régime douanier" />
                  </Field>
                  <ErrorMessage name="regimeDouanier" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                  Catégorie Produit <span class="text-danger">*</span>
                  </label>
                  <Field name="categorieProduit" v-slot="{ field }">
                    <Multiselect :options="categProduitOptions" :searchable="true" multiple="false" track-by="label"
                      label="label" v-model="field.value" v-bind="field" placeholder="Sélectionner la catégorie produit" />
                  </Field>
                  <ErrorMessage name="categorieProduit" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                  Pays <span class="text-danger">*</span>
                  </label>
                  <Field name="pays" v-slot="{ field }">
                    <Multiselect :options="paysOptions" :searchable="true" multiple="false" track-by="label"
                      label="label" v-model="field.value" v-bind="field" placeholder="Sélectionner la catégorie produit" />
                  </Field>
                  <ErrorMessage name="pays" class="text-danger" />
                </div>
              </div>
              <button
                class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
                type="submit">
                {{ btntext }}
              </button>
            </div>
          </Form>
        </div>
        <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"
          @click="resetValue()"></button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from '../../services/ApiService';
import * as Yup from 'yup';
import { error, success, hideModal } from '../../utils/utils';
import { Tarification } from '@/models/Tarification';
import { Modal } from 'bootstrap';
import Multiselect from '@vueform/multiselect'

export default defineComponent({
  name: "AddModalTarification",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },
  props: {
    item: {
      type: Number,
      default: 0,
    }
  },
  setup(props, { emit }) {
    const tarificationSchema = Yup.object().shape({
      cout: Yup.string().required('Le cout est obligatoire'),
      zone: Yup.string().required("La zone ne peut pas etre vide"),
      typeCargaison: Yup.string().required("Le type de cargaison ne peut pas etre vide"),

    });

    const tarificationForm = ref<Tarification | null>(null);
    const addTarificationModalRef = ref<null | HTMLElement>(null);
    const localItem = ref(props.item);
    const isUPDATE = ref(false);
    const title = ref("Ajouter une tarification");
    const btntext = ref('Ajouter');
    const zoneOptions = ref([]);
    const typeCargaisonOptions = ref([])
    const regimeDouanierOptions = ref([])
    const categProduitOptions = ref([])
    const paysOptions= ref([])



    watch(() => props.item, (newValue) => {
      gettarification(newValue);
      isUPDATE.value = true;
      btnTitle();
    });

    const btnTitle = async () => {
      if (isUPDATE.value) {
        title.value = "Modifier une tarification";
        btntext.value = "Modifier";
      } else {
        title.value = "Ajouter une tarification";
        btntext.value = "Ajouter";
      }
    }

    const fetchzone = async () => {
      try {
        const response = await ApiService.get('/zones?limit=0');
        const zoneData = response.data.data.data;
        zoneOptions.value = zoneData.map((zone) => ({
          value: zone.id,
          label: `${zone.name}`,
        }));
      } catch (error) {
        //
      }
    };

    const fetchTypeCargaison = async () => {
      try {
        const response = await ApiService.get('/cargaisons?limit=0');
        const typeCargaisonData = response.data.data.data;
        typeCargaisonOptions.value = typeCargaisonData.map((typeCargaison) => ({
          value: typeCargaison.id,
          label: `${typeCargaison.libelle}`,
        }));
      } catch (error) {
        //
      }
    };

    const fetchRegime= async () =>{
      try{
        const response= await ApiService.get('/regimes?limit=0');
        const regimeData= response.data.data.data;
        regimeDouanierOptions.value= regimeData.map((regimeDouanier) => ({
          value: regimeDouanier.id,
          label: `${regimeDouanier.name}`,
        }));
      }catch (error) {
        //
      }
    }
    
    const fetchPays= async () =>{
      try{
        const response= await ApiService.get('/pays?limit=0');
        const paysData= response.data.data.data;
        paysOptions.value= paysData.map((pays)=> ({
          value: pays.id,
          label: `${pays.iso2_code} ${pays.iso3_code} ${pays.name_fr} ${pays.name_en}`
        }))
      }catch (error) {
        //
      }
    }

    const fetchCategProduit= async () =>{
      try{
        const  response= await ApiService.get('/categProduits?limit=0');
        const categData= response.data.data.data;
        categProduitOptions.value= categData.map((categProduit) =>({
          value: categProduit.id,
          label: `${categProduit.name}`
        }))
      }catch (error) {
        //
      }
    }

    const gettarification = async (id: number) => {
      return ApiService.get("/tarification/" + id)
        .then(({ data }) => {
          const donnees = data.data;
          for (const key in donnees) {
            tarificationForm.value?.setFieldValue(key,
              (typeof donnees[key] === 'object' && donnees[key] !== null) ? donnees[key].id : donnees[key]
            );
          }
          emit('openmodal', addTarificationModalRef.value);

        })
        .catch(({ response }) => {
          error(response.data.message)
        });
    }

    const addTarification = async (values: any, tarificationForm) => {
      values = values as Tarification;

      if (isUPDATE.value) {
        ApiService.put("/tarification/" + values.id, values)
          .then(({ data }) => {
            if (data.code == 200) {
              success(data.message);
              // tarificationForm.resetForm();
              hideModal(addTarificationModalRef.value);
              isUPDATE.value = false;
              btnTitle();
              emit('close');
            }
          })
          .catch(({ response }) => {
            error(response.data.message);
          });
      } else {
        ApiService.post("/tarification", values)
          .then(({ data }) => {
            if (data.code == 201) {
              success(data.message);
              // tarificationForm.resetForm();
              hideModal(addTarificationModalRef.value);
              emit('close');
            }
          })
          .catch(({ response }) => {
            error(response.data.message);
          });
      }
    };
    onMounted(() => {
      fetchzone();
      fetchTypeCargaison();
      fetchRegime();
      fetchCategProduit();
      fetchPays()
    })
    const resetValue = () => {
      const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
      isUPDATE.value = false;
      formFields.forEach(field => {
        field.value = '';
      });
      btnTitle()
    };



    return {
      tarificationSchema,
      addTarificationModalRef,
      addTarification,
      tarificationForm,
      title, btntext, resetValue,
      zoneOptions,
      typeCargaisonOptions,
     regimeDouanierOptions,
     categProduitOptions,
     paysOptions

    };
  },
});
</script>